import { BarBadgeId, DiggerBadgeId } from "./enums"

export interface Badge {
  id: DiggerBadgeId | BarBadgeId
  title: string
  color: string
}

export const diggerBadges: Badge[] = [
  {
    id: DiggerBadgeId.Father,
    title: "Отец-основатель",
    color: "#4b4c55",
  },
  {
    id: DiggerBadgeId.WhiteRussian,
    title: "Белый русский",
    color: "#7d819e",
  },
  {
    id: DiggerBadgeId.Longliver,
    title: "Идёт до конца",
    color: "#477d44",
  },
  {
    id: DiggerBadgeId.StairsSlayer,
    title: "Укротитель лестниц",
    color: "#72567b",
  },
  {
    id: DiggerBadgeId.Firebender,
    title: "Повелитель огня",
    color: "#cb3632",
  },
]

export const barBadges: Badge[] = [
  {
    id: BarBadgeId.GoodCocktails,
    title: "Хорошие коктейли",
    color: "forestgreen",
  },
  {
    id: BarBadgeId.UniqueCocktails,
    title: "Необычные коктейли",
    color: "royalblue",
  },
  {
    id: BarBadgeId.GoodTincture,
    title: "Хорошие настойки",
    color: "forestgreen",
  },
  {
    id: BarBadgeId.GoodBeer,
    title: "Хорошее пиво",
    color: "forestgreen",
  },
  {
    id: BarBadgeId.BadBeer,
    title: "Плохое пиво",
    color: "firebrick",
  },
  {
    id: BarBadgeId.CraftBeer,
    title: "Крафтовое пиво",
    color: "forestgreen",
  },
  {
    id: BarBadgeId.Sabotage,
    title: "Есть пиво SABOTAGE",
    color: "royalblue",
  },
  {
    id: BarBadgeId.DancePool,
    title: "Танцпол",
    color: "purple",
  },
  {
    id: BarBadgeId.GoodDesign,
    title: "Необычный дизайн",
    color: "purple",
  },
  {
    id: BarBadgeId.Hookah,
    title: "Есть кальяны",
    color: "royalblue",
  },
  {
    id: BarBadgeId.BadMusic,
    title: "Плохая музыка",
    color: "firebrick",
  },
  {
    id: BarBadgeId.GoodMusic,
    title: "Хорошая музыка",
    color: "forestgreen",
  },
  {
    id: BarBadgeId.Games,
    title: "Настольные игры",
    color: "royalblue",
  },
]
